export enum Permission {
  Notifications = 'notifications',
  EmailLogsView = 'storefront_pro_email_logs.view',
}
